module.exports = __webpack_public_path__ + "static/img/05.7c5ce48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/05.jpg
// module id = wzni
// module chunks = 0